const ITEMS = [
  { key: "upcoming", label: "Upcoming sessions", color: "text-white" },
  { key: "today", label: "Booked today", color: "text-[#FF3333]" },
  { key: "cancelled", label: "Cancelled", color: "text-zinc-400" },
  { key: "customers", label: "Customers", color: "text-[#00F0FF]" },
];

export const StatCards = ({ stats }) => (
  <div className="grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="admin-stats">
    {ITEMS.map((i) => (
      <div key={i.key} className="surface p-6" data-testid={`admin-stat-${i.key}`}>
        <p className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{i.label}</p>
        <p className={`mt-3 font-display text-4xl font-bold ${i.color}`}>{stats ? stats[i.key] : "–"}</p>
      </div>
    ))}
  </div>
);
